var map = {
	"./Flask.png": 5572,
	"./Github.png": 7228,
	"./HTML.png": 9642,
	"./Java.png": 3185,
	"./Javascript.png": 2044,
	"./Node.png": 6973,
	"./Python.png": 491,
	"./React Native.png": 7035,
	"./React.png": 4592,
	"./Spring boot.png": 8768,
	"./firebase.png": 7718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8293;